// The widths a store's own uploads and a theme's own pictures are served at, and the srcset that offers them, so a phone
// downloads a phone-sized picture instead of the full file. Shared, so the storefront's <img> and the server's preload
// of the same picture ask for the same files.

/** Every width an upload may be resized to; anything else is refused, so the resized copies kept stay few. */
export const IMAGE_WIDTHS = [320, 480, 640, 828, 1080, 1440, 1920] as const;

/** A store's own upload: /uploads/<store id>/<stored name> of a picture the resizer can read. */
const OWN_PICTURE = /\/uploads\/[0-9a-f-]{36}\/[0-9a-f-]{36}\.(?:webp|jpe?g|png|avif)$/i;

/** A theme's own picture: /theme-assets/<theme>/<file>, as the theme-asset route serves it. */
const THEME_PICTURE = /\/theme-assets\/[a-z0-9]+(?:-[a-z0-9]+)*\/[a-z0-9][a-z0-9_-]*\.(?:webp|jpe?g|png)$/i;

/** How wide the page's lead picture shows: the whole screen, as a hero does. */
export const LEAD_IMAGE_SIZES = '100vw';

/** How wide a product page's pictures show: the whole phone screen, half a wider one. */
export const PRODUCT_MEDIA_SIZES = '(max-width: 767px) 100vw, 50vw';

// Reports whether a width is one the resizer serves.
export const isImageWidth = (width: number): boolean => (IMAGE_WIDTHS as readonly number[]).includes(width);

// Writes the srcset offering an upload or a theme picture at every served width, or null for one the resizer cannot serve.
export function pictureSrcSet(url: string): string | null {
  const bare = url.split('?')[0];
  if (!OWN_PICTURE.test(bare) && !THEME_PICTURE.test(bare)) return null;
  return IMAGE_WIDTHS.map((width) => `${bare}?w=${width} ${width}w`).join(', ');
}
